export const lightTheme = {
  primary: '#3BC0B7',
  primaryLight: '#5dd4cc',
  primaryDark: '#2a9d95',
  secondary: '#2C3E50',
  textPrimary: '#2C3E50',
  background: '#F7F8FA',
  backgroundPaper: '#FFFFFF',
  success: '#4D9C7E',
  error: '#C96A5A',
  errorDark: '#B85748',
  info: '#36A2EB',
  warning: '#FFCE56',

  divider: 'rgba(44, 62, 80, 0.08)',
  textMuted: '#7F8C8D',
  rowEven: '#FAFAFA',
  rowOdd: 'transparent',
  rowComplete: '#E0E0E0',
  textButton: '#FFFFFF',
  cardHover: 'rgba(59, 192, 183, 0.04)',
  inputBorder: 'rgba(44, 62, 80, 0.15)',
  sidebarBg: '#FFFFFF',
  chartColors: ['#3BC0B7', '#2C3E50', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
};
